import { Injectable } from '@angular/core';
import { UrlHelper } from '../helpers';
import { environment } from '../../../environments/environment';

/**
 * Redirect Service
 */
@Injectable()
export class RedirectService {

    navigate(applicationName: string, parts: any, params?: any, target: string = '_self'): void {
        if ((environment.name.short === 'prod' || environment.name.short === 'dev') && `${UrlHelper.getHostname()}/` === environment.envVar.PLAYER_URL.replace('https://', '')) {
            UrlHelper.navigate({ parts: [environment.envVar[applicationName.toUpperCase() + '_URL'], ...parts], params }, target);
        } else {
            switch (applicationName) {
                case 'studio':
                case 'player':
                    return UrlHelper.navigate({ parts: [UrlHelper.getHostname() + '/' + applicationName, ...parts], params }, target);
                case 'app':
                    return UrlHelper.navigate({ parts: [UrlHelper.getHostname(), ...parts], params }, target);
            }
        }
    }
}
